import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { fetchGetProduct, fetchAddonsDigitalSignature } from "./digitalSignatureAPI";

export const getProducts = createAsyncThunk(
	'digitalSignature/getProduct',
	async (pid) => {
		const response = await fetchGetProduct(pid)
		return response;
	}
)

export const getAddons = createAsyncThunk(
	'digitalSignature/getAddons',
	async (pid) => {
		const response = await fetchAddonsDigitalSignature(pid)
		return response;
	}
)

const digitalSignatureSlice = createSlice({
	name: "digitalSignature",
	initialState: {
		status: "",
		error: "",
		price: "",
		name: "",
		addons: [],
		addonsStatus: "",
	},
	extraReducers: (builder) => {
		builder
			.addCase(getProducts.pending, (state) => {
				state.status = 'loading'
			})
			.addCase(getProducts.fulfilled, (state, action) => {
				const resData = action.payload.products.product
				state.status = 'fulfilled'
				if (resData[0].pid === 81) {
					state.price = resData[0].pricing.IDR;
					state.name = resData[0].name;
				}
			})
			.addCase(getProducts.rejected, (state, action) => {
				state.status = 'error'
				state.error = action.error.message
			})
			.addCase(getAddons.pending, (state) => {
				state.addonsStatus = 'loading'
			})
			.addCase(getAddons.fulfilled, (state, action) => {
				state.addonsStatus = 'fulfilled'
				if (action.payload.status && action.payload.data && action.payload.data[0]) {
					state.addons = action.payload.data[0].addons || [];
				}
			})
			.addCase(getAddons.rejected, (state, action) => {
				state.addonsStatus = 'error'
				state.error = action.error.message
			})
	},
})

export default digitalSignatureSlice.reducer;